var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _rect15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectParking1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P1",
    x: 2400.98,
    y: 780.133,
    width: 172,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P2",
    x: 2400.98,
    y: 691.133,
    width: 172,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P3",
    x: 2799,
    y: 690.697,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P4",
    x: 2799,
    y: 779.697,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P5",
    x: 2799,
    y: 889,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P6",
    x: 2799,
    y: 977.697,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P7",
    x: 2799,
    y: 1087,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P8",
    x: 2799,
    y: 1175,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P9",
    x: 2799,
    y: 1284,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P10",
    x: 2799,
    y: 1373,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P11",
    x: 2799,
    y: 1482,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P12",
    x: 2799,
    y: 1571,
    width: 173,
    height: 75,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P13",
    x: 2799,
    y: 1683,
    width: 173,
    height: 75,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P14",
    x: 2799,
    y: 1774.82,
    width: 173,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "A1_P15",
    d: "M2549.41 1501.29V1673.29H2477.41V1501.29H2549.41Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P16",
    d: "M2457 1524.33V1659.33H2385V1524.33H2457Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P17",
    d: "M2347.5 1524.33V1659.33H2275.5V1524.33H2347.5Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P18",
    d: "M2259 1524.33V1659.33H2187V1524.33H2259Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P19",
    d: "M1953 1501V1665H1878V1501H1953Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P20",
    d: "M1863 1501V1665H1788V1501H1863Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P21",
    d: "M1750 1501V1665H1675V1501H1750Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P22",
    d: "M1662 1509V1665H1587V1509H1662Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P23",
    d: "M1567 1535V1665H1492V1535H1567Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P24",
    d: "M1483.5 1570L1369.49 1643.49L1329.99 1582.49L1444 1509.5L1483.5 1570Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P25",
    d: "M1442.99 1473.01L1313.45 1557.24L1273.49 1496.5L1403.5 1413L1442.99 1473.01Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P26",
    d: "M1394.19 1397.89L1264.65 1482.11L1224.69 1421.38L1354.7 1337.88L1394.19 1397.89Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P27",
    d: "M1758.58 1165V1301H1686.58V1165H1758.58Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P28",
    d: "M1863 1165V1337H1791V1165H1863Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P29",
    d: "M1952.17 1165.86V1337.86H1880.17V1165.86H1952.17Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P30",
    d: "M2258.82 1148.28V1320.28H2186.82V1148.28H2258.82Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P31",
    d: "M2347.74 1148.28V1320.28H2275.74V1148.28H2347.74Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P32",
    d: "M1229.28 980.22L1302.76 1093.85L1242.1 1133.34L1169.58 1019.64L1229.28 980.22Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P33",
    d: "M1223.63 1119.85L1087.58 1208.49L1048.81 1148.48L1184.85 1060.83L1223.63 1119.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P34",
    d: "M1177 1047.85L1040.95 1136.49L1002.17 1076.48L1138.22 988.831L1177 1047.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P35",
    d: "M1109 941.849L972.948 1030.49L934.172 970.476L1070.22 882.831L1109 941.849Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P36",
    d: "M1068 878.849L931.948 967.491L893.172 907.476L1029.22 819.831L1068 878.849Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P37",
    d: "M1379.99 758.855L1242.19 848.678L1203.43 788.654L1341.22 699.831L1379.99 758.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P38",
    d: "M1338.75 693.855L1200.95 783.678L1162.19 723.654L1299.98 634.831L1338.75 693.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P39",
    d: "M1277.75 600.855L1139.95 690.678L1101.19 630.654L1238.98 541.831L1277.75 600.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P40",
    d: "M1236.75 535.855L1098.95 625.678L1060.19 565.654L1197.98 476.831L1236.75 535.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P41",
    d: "M1163.75 427.855L1025.95 517.678L987.186 457.654L1124.98 368.831L1163.75 427.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P42",
    d: "M1121.75 362.855L983.947 452.678L945.186 392.654L1082.98 303.831L1121.75 362.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P43",
    d: "M842.748 543.855L704.947 633.678L666.186 573.654L803.978 484.831L842.748 543.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P44",
    d: "M884.748 608.855L746.947 698.678L708.186 638.654L845.978 549.831L884.748 608.855Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P45",
    d: "M655.857 579.719L746.022 718.088L685.217 757.368L596.062 619.005L655.857 579.719Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P46",
    d: "M588.857 623.719L679.022 762.088L618.217 801.368L529.062 663.005L588.857 623.719Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P47",
    d: "M666.64 913.844L531.947 1001.57L493.159 941.565L627.854 854.831L666.64 913.844Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P48",
    d: "M710.64 981.844L575.947 1069.57L537.159 1009.56L671.854 922.831L710.64 981.844Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P49",
    d: "M765.64 1066.84L630.947 1154.57L592.159 1094.56L726.854 1007.83L765.64 1066.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P50",
    d: "M814.64 1140.84L679.947 1228.57L641.159 1168.56L775.854 1081.83L814.64 1140.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P51",
    d: "M873.64 1232.84L738.947 1320.57L700.159 1260.56L834.854 1173.83L873.64 1232.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P52",
    d: "M921.64 1307.84L786.947 1395.57L748.159 1335.56L882.854 1248.83L921.64 1307.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P53",
    d: "M981.64 1398.84L846.947 1486.57L808.159 1426.56L942.854 1339.83L981.64 1398.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P54",
    d: "M1029.64 1472.84L894.947 1560.57L856.159 1500.56L990.854 1413.83L1029.64 1472.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P55",
    d: "M1097.64 1577.84L962.947 1665.57L924.159 1605.56L1058.85 1518.83L1097.64 1577.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P56",
    d: "M1146.28 1651.84L1011.58 1739.57L972.797 1679.56L1107.49 1592.83L1146.28 1651.84Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P57",
    d: "M1211.83 1751.85L1076.5 1840L1037.72 1779.99L1173.04 1692.83L1211.83 1751.85Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "A1_P58",
    d: "M1260.16 1826.9L1125.27 1914.74L1085.34 1853.99L1220.7 1766.88L1260.16 1826.9Z",
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "A1_P59",
    x: 2438,
    y: 1366,
    width: 135,
    height: 72,
    fill: "#A0BA3B",
    fillOpacity: 0.42,
    stroke: "#A0BA3B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectParking1);
export default __webpack_public_path__ + "static/media/select_parking_1.babe27b3e2c3c97db72f495812fbb09c.svg";
export { ForwardRef as ReactComponent };